package org.example.project.enginetabular

internal fun mergeTabularExternalColumns(
    current: List<Pair<String, List<String>>>,
    incoming: List<Pair<String, List<String>>>,
    columns: Set<Int>
): List<Pair<String, MutableList<String>>> {
    val incomingById = incoming.toMap()
    return current.map { row ->
        val values = incomingById[row.first]
        if (values == null || columns.none { it in row.second.indices && it in values.indices && row.second[it] != values[it] }) {
            row.first to row.second.toMutableList()
        } else {
            row.first to row.second.mapIndexed { index, value ->
                if (index in columns) values.getOrElse(index) { value } else value
            }.toMutableList()
        }
    }
}
